import { Injectable } from '@angular/core';
import { BillingInvoiceEditService } from '../billing-invoice/billing-invoice-edit.service';
import { BillingInvoiceItemEditInfo } from '../../../model/billing/billing-invoice-item-edit-info';
import { BillingInvoice } from '../../../model/billing/billing-invoice';
import { ReportViewer } from '../../../model/report-viewer';
import { BillingInvoiceEditInfo } from '../../../model/billing/billing-invoice-edit-info';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { BillingInvoiceCreateResponse } from '../../../model/billing/billing-invoice-create-response';
import { ClientSearch } from '../../../model/client-search';
import { InvoiceNumberBookPoint } from '../../../model/invoice-number-book-point';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceManualCreditEditService extends BillingInvoiceEditService {

  invoiceId?: number;
  sectorId: number;
  items: BillingInvoiceItemEditInfo[] = [];

  isVisibleIsRejectedOptions(): boolean {
    return true;
  }

  isVisibleDatesFromTo(): boolean {
    return true;
  }

  isVisibleBillingInvoiceItemManual(): boolean {
    return true;
  }

  isVisibleBillingInvoiceItemEntity(): boolean {
    return false;
  }

  noDeleteItemManual(): boolean {
    return true;
  }

  isVisibleBillingInvoiceItemEntityCredit(): boolean {
    return false;
  }

  isVisibleCirculacionAbierta(): boolean {
    return false;
  }

  isVisibleBillingInvoiceAssociate(): boolean {
    return true;
  }

  setBillingInvoiceManualParams(sectorId: number,
    invoiceTypeId: number) {

      throw new Error('Method not implemented.');
  }

  setBillingInvoiceParams(sectorId: number,
    preBillingId: number, invoiceTypeId: number) {

    throw new Error('Method not implemented.');
  }

  setBillingInvoiceCreditParams(sectorId: number,
    billingInvoiceId?: number) {

    this.invoiceId = billingInvoiceId;
    this.sectorId = sectorId;
  }

  async billingInvoiceCreate(clientSearch: ClientSearch,
      invoiceNumberBookPoint: InvoiceNumberBookPoint,
      billingInvoice: BillingInvoice,
      medicalAppointmentProcedureExcludeIds: number[],
      items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse> {

    return await this.billingInvoiceManualCreditService.billingInvoiceCreate(
      clientSearch, invoiceNumberBookPoint, billingInvoice, items == null ? this.items : items);
  }

  getParentInvoiceCompleteNumber(): string {
    return '';
  }

  getInvoiceTypeId(): number {

    return InvoiceType.Credit;
  }

  async getBillingInvoiceEditInfo(): Promise<BillingInvoiceEditInfo> {

    const info = await this.billingInvoiceManualCreditService
      .getBillingInvoiceWithItemEditInfo( this.sectorId, this.invoiceId );
     this.items = info.Items;
     return info.BillingInvoiceEditInfo;
  }

  async getBillingInvoiceReport(billingInvoiceId: number): Promise<ReportViewer> {

    return await this.billingInvoiceManualCreditService
      .getBillingInvoiceReport( billingInvoiceId );
  }

  getBillingInvoiceItemEditInfos(): Promise<BillingInvoiceItemEditInfo[]> {

    return Promise.resolve( this.items );
  }

  async calculateBillingInvoice(billingInvoice: BillingInvoice,
    items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoice> {

      const calculate = await this.billingInvoiceAmountService
        .calculateBillingInvoiceAmount( 
          billingInvoice.ClientSearch,
          billingInvoice.InvoicePoint,
          items == null ? this.items : items);

      billingInvoice.InvoiceTaxes = calculate.InvoiceTaxes;
      billingInvoice.Amount = calculate.Amount;
      billingInvoice.AmountWithTax = calculate.AmountWithTax;

      return billingInvoice;

  }
}
